import React, { useEffect, useState } from "react";
import { GetCandidatePie } from "../../../../apiServices";
import { useSelector } from "react-redux";
import styles from "./adminTable.module.scss";

function AdminTable() {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const JobsFilter = useSelector(
    (state) => state.CandidateDashboardFilterDetails.CandidateDashboard
  );

  const fetchData = async () => {
    try {
      const response = await GetCandidatePie(JobsFilter);
      if (response.success && response.interviews.length > 0) {
        const data = response.interviews.map((interview) => ({
          name: interview.user_name,
          joining: interview.joined_count.toString(),
          leftCompany: interview.left_count.toString(),
          currentlyWorking: interview.currently_working.toString(),
        }));
        setTableData(data);
      }
    } catch (error) {
      console.error("Failed to fetch data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JobsFilter]);

  return (
    <div>
      {loading ? (
        <p aria-busy="true" aria-live="polite">
          Loading data...
        </p>
      ) : (
        <div className={styles.container}>
          <table className={styles.table}>
            <thead>
              <tr className={styles.headerRow}>
                <th className={styles.cell}>Name</th>
                <th className={styles.cell}>Joined</th>
                <th className={styles.cell}>Left Company</th>
                <th className={styles.cell}>Currently Working</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index} className={styles.row}>
                  <td className={styles.cell}>{row.name}</td>
                  <td className={styles.cell}>{row.joining}</td>
                  <td className={styles.cell}>{row.leftCompany}</td>
                  <td className={styles.cell}>{row.currentlyWorking}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminTable;
